import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community'
import {
  LicenseManager,
  SetFilterModule,
  CellSelectionModule,
  ClipboardModule
} from 'ag-grid-enterprise'

import { App } from '@/App'
import { env } from '@/app/env'
import { installPreloadErrorRecovery } from '@/app/preload-error'
import { initSentry } from '@/app/sentry'
import { applyTabTitle } from '@/app/tab-title'

import './styles.css'

if (env.agGridEnterpriseLicenseKey) {
  LicenseManager.setLicenseKey(env.agGridEnterpriseLicenseKey)
}

ModuleRegistry.registerModules([
  AllCommunityModule,
  SetFilterModule,
  CellSelectionModule,
  ClipboardModule
])

initSentry()
installPreloadErrorRecovery()
applyTabTitle()

const container = document.getElementById('root')
if (!container) throw new Error('Root element #root not found')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>
)
